export const CREATE_NEWS_REQUEST = 'CREATE_NEWS_REQUEST';
export const CREATE_NEWS_SUCCESS = 'CREATE_NEWS_SUCCESS';
export const CREATE_NEWS_FAILURE = 'CREATE_NEWS_FAILURE';
export const RESET_CREATE_NEWS_DATA = 'RESET_CREATE_NEWS_DATA';

export const requestCreateNews = (formData) => ({ type: CREATE_NEWS_REQUEST, payload: formData });
export const receiveCreateNews = (data) => ({ type: CREATE_NEWS_SUCCESS, payload: data });
export const createNewsFailed = (error) => ({ type: CREATE_NEWS_FAILURE, payload: error });
export const resetCreateNewsData = () => ({ type: RESET_CREATE_NEWS_DATA});